module.exports = __webpack_public_path__ + "static/media/drdiary_05.f916127d.png";